import { useEffect, useRef } from "react";

/**
 * Custom hook to ensure the effect is executed just once.
 */
export const useEffectOnce = (callback) => {
  const ref = useRef(false);

  useEffect(() => {
    if (ref.current) {
      return;
    }

    ref.current = true;

    callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
